var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "group" }, [
    _vm.tableData && _vm.tableData.length
      ? _c(
          "div",
          { staticClass: "content" },
          [
            _c("img", {
              staticStyle: { display: "block", width: "10%", margin: "0 auto" },
              attrs: { src: require("./img/jingyingxiaozu@3x.png") }
            }),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.tableData[0].teamName))]),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { "font-size": "16px", "font-weight": "400" } },
              [_vm._v("小组标语：" + _vm._s(_vm.tableData[0].title))]
            ),
            _vm._v(" "),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData, maxHeight: "400" }
              },
              [
                _c(
                  "el-table-column",
                  { attrs: { width: "50" } },
                  [
                    [
                      _c("img", {
                        staticStyle: { width: "14px", "margin-top": "9px" },
                        attrs: { src: require("./img/jing@3x.png") }
                      })
                    ]
                  ],
                  2
                ),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "studentName", label: "成员姓名" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "stationName", label: "岗位" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return _vm._l(scope.row.stations, function(item) {
                            return _c(
                              "div",
                              {
                                key: item.id,
                                staticStyle: { color: "#5397F7" }
                              },
                              [_vm._v(_vm._s(item.postName))]
                            )
                          })
                        }
                      }
                    ],
                    null,
                    false,
                    145659884
                  )
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "mobile", label: "联系方式" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("p", [_vm._v("岗位制度")]),
            _vm._v(" "),
            _c("div", { staticClass: "textContent" }, [
              _c(
                "ul",
                _vm._l(_vm.postList, function(item, i) {
                  return _c("li", { key: i }, [
                    _c("span", { staticStyle: { color: "#5397F7" } }, [
                      _vm._v(
                        _vm._s(item.name) + _vm._s(item.remark ? "：" : "")
                      )
                    ]),
                    _vm._v(_vm._s(item.remark) + "\n         ")
                  ])
                }),
                0
              )
            ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65482f2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65482f2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/group/index.vue
// module id = null
// module chunks = 